export const removeAccents = valor => {
  if (!valor) {
    return valor
  }

  return valor.normalize('NFD').replace(/[\u0300-\u036f]|[˜~^ˆ´`]/g, '')
}
